module.exports = __webpack_public_path__ + "static/Certified engineers-5fcc9ee4e99796d08893778820890192.png";